// Import of actions
import * as HcpUserActions from "../actions/hcp-user.actions";
import { IDiaprofilHcp } from "../../models/types";

export type HcpUsersState = IDiaprofilHcp[];

export const initialState: HcpUsersState = [];

export function hcpUserReducer(
  state = initialState,
  action: HcpUserActions.Actions
): HcpUsersState {
  switch (action.type) {
    case HcpUserActions.RESET_STATE: {
      return initialState;
    }

    case HcpUserActions.ADD: {
      return state.find(hcp => hcp.fhirId === action.payload.fhirId)
        ? state
        : [...state, action.payload];
    }

    case HcpUserActions.REPLACE: {
      return [
        ...state.filter(hcp => hcp.fhirId !== action.payload.fhirId),
        action.payload // payload is FHIR resource
      ];
    }

    case HcpUserActions.UPDATE: {
      return state.map(hcp => {
        return hcp.fhirId === action.payload.fhirId
          ? { ...hcp, ...action.payload }
          : hcp;
      });
    }

    case HcpUserActions.DELETE: {
      return state.filter(hcp => hcp.fhirId !== action.payload.fhirId);
    }

    // We do not have a reducer for the LOAD action as it doesn't alter the state
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/store/reducers/hcp-user.reducer.ts